import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.76, 0, 0.24, 1];

// Scroll-triggered fade + rise for blocks.
// `immediate` = joue l'animation au montage (contenu au-dessus de la ligne de
// flottaison : sinon il reste invisible tant que l'utilisateur n'a pas scrollé).
// Respecte prefers-reduced-motion : contenu visible immédiatement.
export const Reveal = ({ children, delay = 0, y = 40, className = "", immediate = false, ...rest }) => {
  const reduce = useReducedMotion();

  if (reduce) {
    return (
      <div className={className} {...rest}>
        {children}
      </div>
    );
  }

  const anim = immediate
    ? { animate: { opacity: 1, y: 0 } }
    : { whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-80px" } };

  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      {...anim}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

// Masked line-by-line reveal. `lines` = array of strings.
export const MaskedLines = ({ lines, className = "", lineClassName = "", start = 0.2 }) => {
  const reduce = useReducedMotion();

  return (
    <span className={className}>
      {lines.map((line, i) => {
        const extra =
          typeof lineClassName === "function"
            ? lineClassName(i, lines.length)
            : lineClassName;
        if (reduce) {
          return (
            <span key={i} className={`block ${extra}`}>
              {line}
            </span>
          );
        }
        return (
          <span key={i} className="reveal-mask">
            <motion.span
              className={`block ${extra}`}
              initial={{ y: "110%" }}
              animate={{ y: "0%" }}
              transition={{ duration: 1.1, ease: EASE, delay: start + i * 0.13 }}
            >
              {line}
            </motion.span>
          </span>
        );
      })}
    </span>
  );
};
